<template>
    <tr class="kgr-table__row">
        <td class="kgr-table__cell kgr-table__cell--centered">
            <kgr-isbj-status :status="{ color: 'yellow', title: $t('Die Start- und Enddaten von Gutscheinen und Regelzeiten dürfen nicht voneinander abweichen. Bitte überprüfen Sie die Einträge.') }" />
        </td>
        <td class="kgr-table__cell">
            <a
                v-if="child.kindergarten.hasWriteAccess"
                :href="child.loginLink"
            >
                <span class="kgr-text--bold">{{ child.name.lastName }}</span>
            </a>
        </td>
        <td class="kgr-table__cell">
            <a
                v-if="child.kindergarten.hasWriteAccess"
                :href="child.loginLink"
            >
                <span class="kgr-text--bold">{{ child.name.firstName }}</span>
            </a>
        </td>
        <td class="kgr-table__cell">
            {{ child.kindergarten.name }}
        </td>
        <td
            colspan="5"
            class="kgr-table__cell diff"
        >
            {{ $t('Die Start- und Enddaten von Gutscheinen und Regelzeiten dürfen nicht voneinander abweichen. Bitte überprüfen Sie die Einträge.') }}
        </td>
        <td class="kgr-table__cell"></td>
        <td class="kgr-table__cell"></td>
    </tr>
</template>

<script>
import IsbjStatus from './IsbjStatus';

export default {
    components: {
        'kgr-isbj-status': IsbjStatus,
    },
    props: {
        child: {
            type: Object,
            required: true,
        },
    },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.diff {
    background-color: #f9f6c1;
}
</style>
